var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.78px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "85.06 117.32 46.95 174.26 85.06 174.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.48,73.35S70.4,77.54,70.4,93v81.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "131.01 117.32 169.12 174.26 131.01 174.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.59,73.35S145.67,77.54,145.67,93v81.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97,68.9c0-6.45,4.84-11.68,10.8-11.68s10.81,5.23,10.81,11.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.9,51.37a22.19,22.19,0,0,1,22.19-22.19c12.25,0,21.87,10.25,21.87,22.5l-.1,10v111c0,4.14,0,18-13.82,18H100.55c-11.31,0-14.66-13.86-14.66-18V51.37Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.03,
    y1: 79.57,
    x2: 97.03,
    y2: 90.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.03,
    y1: 101.13,
    x2: 97.03,
    y2: 112.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.03,
    y1: 122.68,
    x2: 97.03,
    y2: 133.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/ROCKET.c34b451469be9d9539c48832d6ca0307.svg";
export { ForwardRef as ReactComponent };